export enum MeasurementCategoryType {
    None,
    Distance,
    Fuel,
    FuelEfficiency,
    Temperature,
    Fluid,
    Weight,
    Currency,
    AlcoholContent,
    Event, 
    Speed
}
